import { Record as record } from 'immutable';

import trainTime from '../../lib/TrainTime';
import { resolve } from '../../helpers/LinkMapper';


const defaults = {
    originalCardNumber: null,
    expiryDate: null,
    isReadyToTransfer: false,
    isNewCardRequestConfirmed: false,
    isNewCardAdultCard: false,
    isNewCardConfirmationRequired: false,
};

class SmartcardReplacementSummary extends record(defaults) {
    static fromJSON(json = {}) {
        return new SmartcardReplacementSummary({
            originalCardNumber: resolve(json.originalCardNumber).with(Number),
            expiryDate: resolve(json.expiryDate).with(trainTime),
            isReadyToTransfer: resolve(json.isReadyToTransfer).with(Boolean),
            isNewCardRequestConfirmed: resolve(json.isNewCardRequestConfirmed).with(Boolean),
            isNewCardAdultCard: resolve(json.isNewCardAdultCard).with(Boolean),
            isNewCardConfirmationRequired: resolve(json.isNewCardConfirmationRequired).with(Boolean),
        });
    }

    getDaysUntilExpiry() {
        const expiry = this.get('expiryDate');
        if (!expiry) {
            return -1;
        }

        const today = trainTime().startOf('day');
        const expiryDay = expiry.clone().startOf('day');

        return expiryDay.diff(today, 'days');
    }
}

export default SmartcardReplacementSummary;
